let css = require('./header.css');
let { pluralize } = require('../../../../../helpers/utils');
let treeHelper = require('../../../../../helpers/tree');

class Header {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            let selectedLeafs = treeHelper.getSelectedLeafs(data.leafs, data.selected);
            let count = selectedLeafs.length;

            let title = count ? `${count} ${pluralize(count, this.$context.props.pluralized)}` :
                                this.$context.props.defaultTitle;

            return Object.assign({}, data, { title }, { css });
        });
    }
}

module.exports = {
    constructor: Header
};



// WEBPACK FOOTER //
// ./components/common/custom-order/filterable-tree/count-header/index.js